export default {
      id: "settings-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#settings-usage",
      toString: function () {
        return this.url;
      }
    }